import dayjs from "dayjs";
import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  input,
  viewChild
} from "@angular/core";
import { VgApiService } from "@videogular/ngx-videogular/core";
import { IQueueAsset, IThemeOptions, ThemeParam } from "../../models";
import { DeviceService } from "../../services/device.service";
import { AssetTypeEnum } from "../../core-ui.enums";
import { formatTimezone } from "../../services/utils";

@Component({
  selector: "app-waiting",
  templateUrl: "./waiting.component.html",
  styleUrls: ["./waiting.component.scss"],
  standalone: false,
})
export class WaitingComponent implements OnInit, OnDestroy {
  readonly startAt = input<Date>(undefined);
  readonly theme = input<IThemeOptions>(undefined);
  readonly timezone = input<string>(undefined);
  readonly queueName = input<string>(undefined);
  readonly queueId = input<string>(undefined);

  readonly iFrameRef = viewChild<ElementRef<HTMLIFrameElement>>("frame");

  isNotPlaying = false;
  timezoneOffset: string;
  videoSrc: string;
  imageSrc: string;
  isVideoAvailable = false;
  isImageAvailable = false;

  private startedPlaying = false;

  constructor() {}

  ngOnInit() {
    const timezone = this.timezone();
    if (timezone) {
      this.timezoneOffset = formatTimezone(
        dayjs.tz(this.startAt(), timezone)
      );
    }

    if (this.isAssetPerQueue) {
      let asset: IQueueAsset;
      if (this.queueId()) {
        asset = this.theme()?.[ThemeParam.ASSET_PER_QUEUE]?.find(
          (a) => a.queueId === this.queueId()
        );
      } else if (this.queueName()) {
        asset = this.theme()?.[ThemeParam.ASSET_PER_QUEUE]?.find(
          (a) => a.queueName === this.queueName()
        );
      }

      if (asset) {
        switch (asset.type) {
          case AssetTypeEnum.video:
            this.isVideoAvailable = !!asset.url;
            this.videoSrc = asset.url;
            break;
          case AssetTypeEnum.image:
            this.isImageAvailable = !!asset.url;
            this.imageSrc = asset.url;
        }
      }
    } else {
      const theme = this.theme();
      switch (theme?.[ThemeParam.QUEUE_ASSET_TYPE]) {
        case AssetTypeEnum.video:
          this.isVideoAvailable = !!theme?.[ThemeParam.QUEUE_VIDEO_URL];
          this.videoSrc = theme[ThemeParam.QUEUE_VIDEO_URL];
          break;
        case AssetTypeEnum.image:
          this.isImageAvailable = !!theme?.[ThemeParam.QUEUE_VIDEO_URL];
          this.imageSrc = theme[ThemeParam.QUEUE_VIDEO_URL];
          break;
      }
    }
  }

  ngOnDestroy() {
    // this.clearTimers();
  }

  get isAssetPerQueue() {
    return this.theme()?.[ThemeParam.ASSET_PER_QUEUE_ENABLED];
  }

  get isEmbeddedVideo(): boolean {
    return !!this.theme()?.embeddableVideoUrl;
  }

  get scheduledDate() {
    return this.startAt();
  }

  get isMobile() {
    return DeviceService.isMobile;
  }

  imgLoadFailed(e) {
    this.isImageAvailable = false;
  }

  onPlayerReady(api: VgApiService) {
    api.getDefaultMedia().subscriptions.canPlay.subscribe(() => {
      // first it was Safari, then others (Google, and Firefox) followed,
      // thus we need to mute at this point
      api.volume = 0;
      // if it hasn't started playing, show the play overlay and make it manual
      setTimeout(() => {
        if (!this.startedPlaying) {
          this.isNotPlaying = true;
        }
      }, 300);
      api.play();
    });
    api.getDefaultMedia().subscriptions.playing.subscribe(() => {
      this.startedPlaying = true;
    });
  }
}
